<template>
    <div class="loader-wrapper" :class="isLocal ? 'local-wrapper': ''" v-if="isLoading">
      <Spinner
        :loading="isLoading"
        :color="spinnerColor"
        :height="spinnerHeight"
        :width="spinnerWidth"
        :margin="spinnerMargin"
        :radius="spinnerRadius"
      />
    </div>
  </template>
  
  <script>
  import Spinner from 'vue-spinner/src/FadeLoader.vue';
  
  export default {
    name: 'BaseSpinner',
    components: {
      Spinner
    },
    props: {
      spinnerColor: {
        type: String,
        default: function() {
          return 'var(--main-spinner-color)'
        }
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      isLocal: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: '10px'
      }
    },
    computed: {
      spinnerSizeNumber() {
        return parseFloat(this.size) || 10;
      },
      spinnerHeight() {
        return `${this.spinnerSizeNumber * 0.75}px`;
      },
      spinnerWidth() {
        return `${this.spinnerSizeNumber * 0.25}px`;
      },
      spinnerMargin() {
        return `${this.spinnerSizeNumber * 0.1}px`;
      },
      spinnerRadius() {
        return `${this.spinnerSizeNumber}px`;
      }
    }
  }
  </script>
  
  <style scoped>
    .loader-wrapper {
      position: fixed;
      display: flex;
      width: 100vw;
      height: 100vh;
      top: 0;
      left: 0;
      background-color: var(--main-spinner-wrapper-bgc);
      z-index: 99999;
      align-items: center;
      justify-content: center;
      }
    .local-wrapper {
      position: inherit;
      background-color: var(--main-local-spinner-wrapper-bgc);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: inherit;
      max-width: 100%;
    }
  </style>
  